module.exports = __webpack_public_path__ + "img/icon-status-01.18d3b630.svg";